import { createAction } from '@ngrx/store';

export const changeSidenavState = createAction(
    '[Sidenav] Sidenav Changed State'
);
